/**
 * Schema Resources
 *
 * Provides access to validation schema information.
 */

import { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import schemaCatalog from '../data/schema-catalog.json' with { type: 'json' };
import type { SchemaCatalog } from '../types.js';

const schemas = schemaCatalog as SchemaCatalog;

/**
 * Register schema-related resources
 */
export function registerSchemaResources(server: McpServer): void {
  // All schemas
  server.resource('schemas://all', 'schemas://all', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(schemas, null, 2),
      },
    ],
  }));

  // Auth schemas
  server.resource('schemas://auth', 'schemas://auth', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(schemas.sections.auth, null, 2),
      },
    ],
  }));

  // Common schemas
  server.resource('schemas://common', 'schemas://common', async (uri) => ({
    contents: [
      {
        uri: uri.href,
        mimeType: 'application/json',
        text: JSON.stringify(schemas.sections.common, null, 2),
      },
    ],
  }));
}
